/**
 * Pure markup helpers for the FilePond preview.
 *
 * Extracted from `filepond.wc.ts` so the remove-button show/hide decision is
 * unit-testable WITHOUT importing the web component — importing that transitively
 * loads `filepond` + `filepond-plugin-file-poster`, which touches the canvas API
 * (`createRadialGradient`) at module-load time and crashes under jsdom. This
 * module has no FilePond dependency, so it tests cleanly.
 */

/** The remove ("X") button markup shown on a populated file preview. */
export const REMOVE_BUTTON_CLASS = 'c-fp-upload__preview-remove';

export const removeButtonMarkup = `
                      <button type="button" class="${REMOVE_BUTTON_CLASS}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                          <path d="m5 19 7-7m7-7-7 7m0 0 7 7L5 5" stroke="currentColor" stroke-width="1"></path>
                        </svg>
                      </button>
                    `;

/**
 * Build the remove-button markup for the preview. Shown only when a picture is
 * present AND removal is allowed. `hideRemove` opts out (e.g. where removal is
 * not yet backed by a backend delete), keeping the picker usable for uploads.
 */
export const buildRemoveButtonMarkup = ({
  pictureSrc,
  hideRemove,
}: {
  pictureSrc?: string;
  hideRemove?: boolean;
}): string => (pictureSrc && !hideRemove ? removeButtonMarkup : '');
